import type { FaireProductEntity } from "../../entity_types/product";

export const p_9nkefzundf: FaireProductEntity = {
  token: "p_9nkefzundf",
  type: "product",
  name: "Organic Cotton Tea Towel - Werner's Nomenclature of Colours",
  brandToken: "b_u89gdyfh23",
  brandName: "Roomytown Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/a90973f536f8fd6b5319a2f8272c526b39a3f4662942e7e44e97515842b1e2ae.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/578743a7db5eaa58f8afc040e87380d366efb024737bbc45184681becac34b04.jpeg",
    "https://cdn.faire.com/fastly/02c01eedce647334bc18e56ebe6f264e00be15d8fbd63aa615097336c6562c56.jpeg",
  ],
  priceDollars: 9,
  description:
    "This 100% Organic Cotton Tea Towel captures the historial charm of Werner's Nomenclature of Colours, used by pioneers like Charles Darwin to categorise colours through nature's inspiration. Roomytown's design team in Bath, UK, have curated the design using an adaptation of Werner's colour swatches published by P. Syme in 1821. This 100% Organic Cotton Tea Towel comes neatly folded and packaged with a fabric ribbon. Included hanging loop. Machine washable for everyday use in your kitchen\n\nH 710mm x W 460mm / H 28\" x W 18.1\"",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-24T21:40:43.851Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
